﻿export class ZenAvatar
{
    generateAvatar = (canvasId: string, initials: string, size: number, bgColor?: string, textColor: string = "#fff", roundShape: boolean = true): void => {
        const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
        if (!canvas) return;
        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        const borderWidth = 4; // Border thickness
        const gap = 2; // Transparent gap size
        const totalSize = size + borderWidth * 2 + gap * 2; // Adjusted canvas size

        canvas.width = totalSize;
        canvas.height = totalSize;

        // Center coordinates
        const centerX = totalSize / 2;
        const centerY = totalSize / 2;
        const avatarSize = size;
        const borderSize = avatarSize + gap * 2 + borderWidth;

        var initialsColour = this.getRandomColor(initials);

        // 1. Draw Outer Border
        ctx.fillStyle = bgColor || initialsColour; // Change this to preferred border color
        if (roundShape) {
            // Circular border
            ctx.beginPath();
            ctx.arc(centerX, centerY, borderSize / 2, 0, Math.PI * 2);
            ctx.fill();
            ctx.closePath();
        } else {
            // Square border
            ctx.fillRect(centerX - borderSize / 2, centerY - borderSize / 2, borderSize, borderSize);
        }

        // 2. Erase Transparent Gap
        ctx.globalCompositeOperation = "destination-out";
        ctx.fillStyle = "rgba(0,0,0,1)"; // Fully erase
        if (roundShape) {
            ctx.beginPath();
            ctx.arc(centerX, centerY, (avatarSize / 2) + gap, 0, Math.PI * 2);
            ctx.fill();
            ctx.closePath();
        } else {
            ctx.fillRect(centerX - (avatarSize / 2 + gap), centerY - (avatarSize / 2 + gap), avatarSize + gap * 2, avatarSize + gap * 2);
        }

        // Reset composite operation for normal drawing
        ctx.globalCompositeOperation = "source-over";

        // 3. Draw Avatar Background
        ctx.fillStyle = bgColor || initialsColour;
        if (roundShape) {
            ctx.beginPath();
            ctx.arc(centerX, centerY, avatarSize / 2, 0, Math.PI * 2);
            ctx.fill();
            ctx.closePath();
        } else {
            ctx.fillRect(centerX - avatarSize / 2, centerY - avatarSize / 2, avatarSize, avatarSize);
        }

        // 4. Draw Initials
        ctx.font = `${avatarSize / 2}px Arial`;
        ctx.fillStyle = textColor;
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText(initials, centerX, centerY);
    };

    private getRandomColor(input: string): string {
        let hash = 0;
        for (let i = 0; i < input.length; i++) {
            hash = input.charCodeAt(i) + ((hash << 5) - hash);
        }
        const r = hash & 255;
        const g = (hash >> 8) & 255;
        const b = (hash >> 16) & 255;
        return `rgb(${r}, ${g}, ${b})`;
    }
}